import TopNavbar from "../Navbar";
import React, { useState, useEffect } from "react";
import { LIVE_URL } from "../../env";
import axios from "axios";
import './index.scss'
import Loader from "../../Components/Loader/Loader";
import Modal from 'react-bootstrap/Modal';
import { Button, } from "react-bootstrap";
import { log_firebase_event } from "../..";

export default function UserMaster() {
    let [loader, setLoader] = useState(false)

    const KEY_CATEGORY = 'CategoryName';
    const KEY_SUB_CATEGORY = 'SubCategoryName';
    const KEY_BRAND_TYPE = 'BrandType';
    const KEY_BRAND_NAME = 'BrandName';
    const KEY_VENDORS = 'Vendors';
    const KEY_STOCK_TYPE = 'StockType';

    const KEY_ID_CATEGORY = 'CategoryID'
    const KEY_ID_SUB_CATEGORY = 'SubCategoryID'
    const KEY_ID_BRAND = 'BrandID'


    const [searchKey, setSearchKey] = useState('')
    const [userData, setUserData] = useState([])
    const [filteredData, setFilteredData] = useState([])
    const [selectedUser, setSelectedUser] = useState(null)
    const [refresh, setRefresh] = useState(false)

    const [status, setStatus] = useState(false)
    const [showMsg, setShowMsg] = useState(false)
    const [responseMessage, setResponseMessage] = useState('')
    const [showBottomSheet, setShowBottomSheet] = useState(false);

    const [showAllocation, setShowAllocation] = useState(false);


    const [categoryMasterList, setCategoryMasterList] = useState([])
    const [subCategoryMasterList, setSubCategoryMasterList] = useState([])
    const [brandMasterList, setBrandMasterList] = useState([])

    const [brandTypeMasterList, setBrandTypeMasterList] = useState([])
    const [vendorMasterList, setVendorMasterList] = useState([])
    const [stockTypeMasterList, setStockTypeMasterList] = useState([])


    const [categorySelectedList, setCategorySelectedList] = useState([])
    const [subCategorySelectedList, setSubCategorySelectedList] = useState([])
    const [brandSelectedList, setBrandSelectedList] = useState([])

    const [brandTypeSelectedList, setBrandTypeSelectedList] = useState([])
    const [vendorSelectedList, setVendorSelectedList] = useState([])
    const [stockTypeSelectedList, setStockTypeSelectedList] = useState([])

    const [allocationCount, setAllocationCount] = useState(0)


    const [hasAllocation, setHasAllocation] = useState(false);
    const [hasAddUpdate, setHasAddUpdate] = useState(false);


    function checkEmailExists(email) {
        const searchedData = userData.filter((user) => {
            let username = user.emailid;
            return username.toLowerCase() === email.toLowerCase();
        });
        return searchedData.length > 0;
    }

    const handleSearch = (e) => {
        setSelectedUser(null)
        const query = e.target.value.toLowerCase();
        setSearchKey(query);
        if (query === '') {
            setFilteredData(userData);
        }

        if (userData && Array.isArray(userData)) {
            const filteredData = userData.filter((user) => {
                let username = user.emailid;
                return username.includes(query);
            });


            setFilteredData(filteredData);
        } else {
            console.error('user data is null or not an array')
        }


    }


    const fetchCommonFilters = async (keyName) => {
        setLoader(true)
        let getAllUsersUrl = LIVE_URL + 'commonFilters'
        let keyID = null
        if (keyName === KEY_CATEGORY) {
            keyID = KEY_ID_CATEGORY;
        } else if (keyName === KEY_SUB_CATEGORY) {
            keyID = KEY_ID_SUB_CATEGORY;
        } else if (keyName === KEY_BRAND_NAME) {
            keyID = KEY_ID_BRAND;
        }
        var payload = {
            'username': localStorage.getItem("emailaddress"),
            'keyID': keyID,
            'keyName': keyName,
            'filterdisable': true,

        }
        axios.post(getAllUsersUrl, payload).then((response) => {
            if (response.status) {

                if (keyName === KEY_CATEGORY) {
                    if (response.data.data) {
                        setCategoryMasterList(response.data.data);
                    }


                    fetchCommonFilters(KEY_SUB_CATEGORY);
                } else if (keyName === KEY_SUB_CATEGORY) {

                    if (response.data.data) {
                        setSubCategoryMasterList(response.data.data);
                    }

                    fetchCommonFilters(KEY_BRAND_NAME)
                } else if (keyName === KEY_BRAND_NAME) {

                    if (response.data.data) {
                        setBrandMasterList(response.data.data);
                    }

                    fetchCommonFilters(KEY_BRAND_TYPE)
                } else if (keyName === KEY_BRAND_TYPE) {

                    if (response.data.data) {
                        setBrandTypeMasterList(response.data.data);
                    }

                    fetchCommonFilters(KEY_STOCK_TYPE)
                } else if (keyName === KEY_STOCK_TYPE) {


                    if (response.data.data) {
                        setStockTypeMasterList(response.data.data);
                    }

                    fetchCommonFilters(KEY_VENDORS)
                } else if (keyName === KEY_VENDORS) {

                    if (response.data.data) {
                        setVendorMasterList(response.data.data);
                    }

                    setLoader(false)

                }

            } else {
                setLoader(false)
            }
        }).catch((err => {
            setLoader(false)
        }))
    }

    const fetchUserAllocation = (user) => {
        setLoader(true)
        let getAllUsersUrl = LIVE_URL + 'getAllocatedFilters'
        var payload = {
            'username': [user.emailid],
        }
        axios.post(getAllUsersUrl, payload).then((response) => {
            if (response.status) {

                if (response.data.data) {
                    setSelectedAllocation(response.data.data)
                }

                setLoader(false)
            } else {
                setLoader(false)
            }
        }).catch((err => {
            setLoader(false)
        }))
    }


    const setSelectedAllocation = (data) => {
        // console.log(data)
        if (data[0]['filters'] !== undefined) {
            const filters = data[0].filters;

            if (filters.hasOwnProperty(KEY_BRAND_TYPE)) {
                let data = filters[KEY_BRAND_TYPE]
                setBrandTypeSelectedList(data.map(item => item[KEY_BRAND_TYPE]));

            }

            if (filters.hasOwnProperty(KEY_ID_CATEGORY)) {
                let data = filters[KEY_ID_CATEGORY]
                setCategorySelectedList(data.map(item => item[KEY_ID_CATEGORY]));
            }

            if (filters.hasOwnProperty(KEY_STOCK_TYPE)) {
                let data = filters[KEY_STOCK_TYPE]
                setStockTypeSelectedList(data.map(item => item[KEY_STOCK_TYPE]));
            }

            if (filters.hasOwnProperty(KEY_ID_SUB_CATEGORY)) {
                let data = filters[KEY_ID_SUB_CATEGORY]
                setSubCategorySelectedList(data.map(item => item[KEY_ID_SUB_CATEGORY]));
            }

            if (filters.hasOwnProperty(KEY_ID_BRAND)) {
                let data = filters[KEY_ID_BRAND]
                setBrandSelectedList(data.map(item => item[KEY_ID_BRAND]));
            }

            if (filters.hasOwnProperty(KEY_VENDORS)) {
                let data = filters[KEY_VENDORS]
                setVendorSelectedList(data.map(item => item[KEY_VENDORS]));
            }

            setAllocationCount(1)

        }

    }

    useEffect(() => {
        log_firebase_event('screen_view', { firebase_screen: 'UserMaster' });

        let featureaccess = JSON.parse(localStorage.getItem('app_features'));
        if (featureaccess.allocation === (localStorage.getItem('emailaddress').length * 20 + 1)) {

            setHasAllocation(true)
        }

        if (featureaccess.addupdate === (localStorage.getItem('emailaddress').length * 30 + 2)) {

            setHasAddUpdate(true);
        }

    }, []);

    useEffect(() => {
        setLoader(true)
        setSearchKey('')
        setSelectedUser(null)
        setShowAllocation(false)
        let getAllUsersUrl = LIVE_URL + 'getbuyouserwithmaclist'
        var payload = {
            'pagesize': 1000,
            'pageno': 1,
            'isactive': 1,
        }
        axios.post(getAllUsersUrl, payload).then((response) => {
            if (response.status) {
                const tempData = [...response.data.data];

                tempData.sort((a, b) => {
                    return new Date(b.createddate) - new Date(a.createddate);
                })
                setUserData(tempData)
                setFilteredData(tempData);
                setSelectedUser(null);
                setLoader(false)
            } else {
                setLoader(false)
            }
        }).catch((err => {
            setLoader(false)
        }))
    }, [refresh])

    useEffect(() => {
        fetchCommonFilters(KEY_CATEGORY);
    }, []);

    const handleClick = (user) => {
        clearAllocation();
        setSelectedUser(user);
        if (hasAllocation) {
            fetchUserAllocation(user);
        }

        setResponseMessage('')
        setShowMsg(false)
    }

    const clearAllocation = () => {
        setAllocationCount(0)
        setCategorySelectedList([])
        setSubCategorySelectedList([])
        setBrandSelectedList([])
        setBrandTypeSelectedList([])
        setStockTypeSelectedList([])
        setVendorSelectedList([])
    }

    const handleUpdateAllocation = () => {

        let filters = {
            // Add other key-value pairs as needed
        };

        // Check if the categorySelectedList has items
        if (categorySelectedList.length > 0) {
            filters[KEY_ID_CATEGORY] = categorySelectedList.map((value) => ({ [KEY_ID_CATEGORY]: value }));
        }

        // Check if the stockTypeSelectedList has items
        if (stockTypeSelectedList.length > 0) {
            filters[KEY_STOCK_TYPE] = stockTypeSelectedList.map((value) => ({ [KEY_STOCK_TYPE]: value }));
        }

        // Check if the brandTypeSelectedList has items
        if (brandTypeSelectedList.length > 0) {
            filters[KEY_BRAND_TYPE] = brandTypeSelectedList.map((value) => ({ [KEY_BRAND_TYPE]: value }));
        }

        // Check if the subCategorySelectedList has items
        if (subCategorySelectedList.length > 0) {
            filters[KEY_ID_SUB_CATEGORY] = subCategorySelectedList.map((value) => ({ [KEY_ID_SUB_CATEGORY]: value }));
        }

        // Check if the brandSelectedList has items
        if (brandSelectedList.length > 0) {
            filters[KEY_ID_BRAND] = brandSelectedList.map((value) => ({ [KEY_ID_BRAND]: value }));
        }

        let payload = {
            'username': [
                selectedUser.emailid
            ],
            'filters': filters
        }

        // console.log('before : ', payload);
        setLoader(true)
        let allocateFiltersUrl = LIVE_URL + 'allocateFilters'

        axios.post(allocateFiltersUrl, payload).then((response) => {
            if (response.status) {
                setShowAllocation(false);
                setShowMsg(true)
                setStatus(true)
                setSelectedUser(null)
                setLoader(false)
            } else {
                setStatus(false)
                setShowMsg(true)
                setLoader(false)
            }
            setResponseMessage(response.data.message)
        }).catch((err => {
            console.error(err)
            setLoader(false)
        }))



    }


    const handleAddUser = (payload) => {
        setLoader(true)
        let getAllUsersUrl = LIVE_URL + 'addbuyousermac'

        axios.post(getAllUsersUrl, payload).then((response) => {
            if (response.data.status) {
                setRefresh(!refresh)
                setLoader(false)
                setShowMsg(true)
                setStatus(true)

            } else {
                setLoader(false)
                setShowMsg(true)
                setStatus(false)
            }

            setResponseMessage(response.data.message)
        }).catch((err => {
            setLoader(false)
            setShowMsg(true)
            setStatus(false)
            setResponseMessage('Exception Occured !')
        }))
    }

    const handleUpdateUser = (payload) => {
        setLoader(true)
        let getAllUsersUrl = LIVE_URL + 'updatebuyousermac'

        axios.post(getAllUsersUrl, payload).then((response) => {
            if (response.data.status) {
                setRefresh(!refresh)
                setLoader(false)
                setShowMsg(true)
                setStatus(true)

            } else {
                setLoader(false)
                setShowMsg(true)
                setStatus(false)

            }
            setResponseMessage(response.data.message)
        }).catch((err => {
            setLoader(false)
            setShowMsg(true)
            setStatus(false)
            setResponseMessage('Exception Occured !')
        }));
    }

    const handleAllocationClick = () => {
        setShowAllocation(true)
    }

    const AddUpdateUser = ({ user, handleAddUser, handleUpdateUser, responseMessage, status, showMsg, handleAllocationClick, allocationCount, checkEmail }) => {
        const [isUpdate, setIsUpdate] = useState(user ? true : false)
        const [name, setName] = useState(user ? user.name : '')
        const [email, setEmail] = useState(user ? user.emailid : '')
        const [isActive, setisActive] = useState(user ? user.isactive === '1' : false)
        const [emailError, setEmailError] = useState('');
        const [isValid, setIsValid] = useState(false);


        const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

        function validateEmail(email) {
            return emailRegex.test(email);
        }
        function endsWell(email) {
            return email.endsWith('.com') || email.endsWith('.in');
        }


        const handleNameChange = (e) => {
            setName(e.target.value)
        }

        const handleEmailChange = (e) => {
            setEmail(e.target.value)

            setIsValid(e.target.value.length > 0 && validateEmail(e.target.value) && endsWell(e.target.value));


            if (e.target.value.length > 0 && validateEmail(e.target.value) && endsWell(e.target.value)) {


                setEmailError('')

                if (!isUpdate) {

                    let name = e.target.value.split("@")[0]
                    let firstName, lastName;
                    if (name.includes(".")) {
                        firstName = name.split(".")[0];
                        lastName = name.split(".")[1];

                        firstName = `${firstName[0].toUpperCase()}${firstName.slice(1)}`
                        lastName = `${lastName[0].toUpperCase()}${lastName.slice(1)}`
                        setName(firstName + " " + lastName);
                    } else {
                        name = `${name[0].toUpperCase()}${name.slice(1)}`

                        setName(name)
                    }


                }

            } else {
                setEmailError('Email Valid Email')

            }
        }
        const handleCheckboxChange = (e) => {
            setisActive(e.target.checked);
        };

        const handleClear = () => {
            setName('')
            setEmail('')
            setisActive(false)
            setIsUpdate(false)
        };

        const handAddUpdateAction = () => {

            if (isValid) {
                if (isUpdate) {

                    let payload = {
                        'id': user.id,
                        'isactive': isActive ? '1' : '0',
                        'name': name,
                        'username': email,
                        'lastmodifiedby': localStorage.getItem("emailaddress"),
                        'imeinumber': user.imeinumber ? user.imeinumber : '1',
                        'macaddress': user.macaddress ? user.macaddress : '1',
                    }

                    handleUpdateUser(payload);
                } else {

                    if (checkEmail(email)) {
                        setShowMsg(true)
                        setResponseMessage('Email Already present');
                        return;
                    } else {

                        setShowMsg(false)
                        setResponseMessage('')
                        let payload = {
                            'name': name,
                            'username': email,
                            'lastmodifiedby': localStorage.getItem("emailaddress"),
                            'imeinumber': '1',
                            'macaddress': '1',
                        }

                        handleAddUser(payload);
                    }

                }
            }

        }

        return (<>
            <div className="cardPanel">
                <div style={{ marginBottom: '10px' }}>
                    <span style={{ paddingBlock: '10px', fontSize: '16px', }}> {isUpdate ? 'Update User' : 'Add New User'} </span>
                </div>
                <input
                    style={{ padding: '8px', borderRadius: '5px', borderWidth: '1px', marginBottom: '10px', width: '100%' }}
                    value={name}
                    placeholder="name"
                    onChange={handleNameChange}
                >
                </input>

                <input
                    style={{ padding: '8px', borderRadius: '5px', borderWidth: '1px', marginBottom: '10px', width: '100%' }}
                    value={email}
                    placeholder="email"
                    onChange={handleEmailChange}
                >
                </input>
                {emailError !== '' && <div style={{ color: 'red', fontSize: '10px', marginBottom: '10px' }}>
                    {emailError}
                </div>}

                <div>
                    <label style={{ display: 'flex', alignItems: 'center', marginRight: '10px', width: '70px' }}>
                        <input

                            type="checkbox"
                            checked={isActive}
                            onChange={handleCheckboxChange}
                        >
                        </input>
                        <span style={{ marginLeft: '5px' }}>Is Active</span>
                    </label>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-evenly', justifyItems: 'flex-end', marginBlock: '10px' }}>
                    <button
                        disabled={!isValid}
                        className="button-pos" onClick={handAddUpdateAction}>
                        {isUpdate ? 'Update User' : 'Create New User'}
                    </button>

                    <button className="button-neg" onClick={handleClear}>
                        clear
                    </button>
                </div>
                {isUpdate && hasAllocation &&
                    <>
                        <div style={{ display: 'flex', justifyContent: 'space-evenly', alignItems: 'center', marginBlock: '10px' }}>
                            <button className="button-pos" onClick={handleAllocationClick}>
                                Show Allocation
                            </button>
                            <span style={{ justifySelf: 'center' }}>{allocationCount > 0 ? ' Allocation available' : 'No Allocation available'}</span>
                        </div>
                    </>
                }
                <div>
                    {showMsg && <span style={{ color: status ? 'green' : 'red' }}>{responseMessage}</span>}

                </div>
            </div>
        </>
        );
    }


    const handleCategoryChange = (categoryid) => {
        if (categorySelectedList.includes(categoryid)) {
            setCategorySelectedList(categorySelectedList.filter((id) => id !== categoryid));
        } else {
            setCategorySelectedList([...categorySelectedList, categoryid]);
        }
    };

    const CategoryView = () => {
        return (
            <>
                <h5>Category</h5>
                <div className="container-alloc">
                    {categoryMasterList.map((item) => (
                        <div key={item.CategoryID} style={{ marginInline: '5px' }}>
                            <label>
                                <input
                                    style={{ padding: '5px', marginRight: '5px' }}
                                    type="checkbox"
                                    checked={categorySelectedList.includes(item.CategoryID)}
                                    onChange={() => {
                                        handleCategoryChange(item.CategoryID);
                                    }}
                                />

                                {item.CategoryName}
                            </label>
                        </div>
                    ))}
                </div>
            </>
        );
    }

    const handleSubCategoryChange = (categoryid) => {
        if (subCategorySelectedList.includes(categoryid)) {
            setSubCategorySelectedList(subCategorySelectedList.filter((id) => id !== categoryid));
        } else {
            setSubCategorySelectedList([...subCategorySelectedList, categoryid]);
        }
    };

    const SubCategoryView = () => {
        return (
            <>
                <h5>Sub Category</h5>
                <div className="container-alloc">
                    {subCategoryMasterList.map((item) => (
                        <div key={item.SubCategoryID} style={{ marginInline: '5px' }}>
                            <label>
                                <input
                                    style={{ padding: '5px', marginRight: '5px' }}
                                    type="checkbox"
                                    checked={subCategorySelectedList.includes(item.SubCategoryID)}
                                    onChange={() => {
                                        handleSubCategoryChange(item.SubCategoryID);
                                    }}
                                />

                                {item.SubCategoryName}
                            </label>
                        </div>
                    ))}
                </div>
            </>
        );
    }

    const handleBrandTypeChange = (brandType) => {
        if (brandTypeSelectedList.includes(brandType)) {
            setBrandTypeSelectedList(brandTypeSelectedList.filter((id) => id !== brandType));
        } else {
            setBrandTypeSelectedList([...brandTypeSelectedList, brandType]);
        }
    };

    const BrandTypeView = () => {
        return (
            <>
                <h5>Brand Type</h5>
                <div className="container-alloc">
                    {brandTypeMasterList.map((item) => (
                        <div key={item.BrandType} style={{ marginInline: '5px' }}>
                            <label>
                                <input
                                    style={{ padding: '5px', marginRight: '5px' }}
                                    type="checkbox"
                                    checked={brandTypeSelectedList.includes(item.BrandType)}
                                    onChange={() => {
                                        handleBrandTypeChange(item.BrandType);
                                    }}
                                />

                                {item.BrandType}
                            </label>
                        </div>
                    ))}
                </div>
            </>
        );
    }

    const handleStockTypeChange = (stockType) => {
        if (stockTypeSelectedList.includes(stockType)) {
            setStockTypeSelectedList(stockTypeSelectedList.filter((id) => id !== stockType));
        } else {
            setStockTypeSelectedList([...stockTypeSelectedList, stockType]);
        }
    };

    const StockTypeView = () => {
        return (
            <>
                <h5>Stock Type</h5>
                <div className="container-alloc">
                    {stockTypeMasterList.map((item) => (
                        <div key={item.StockType} style={{ marginInline: '5px' }}>
                            <label>
                                <input
                                    style={{ padding: '5px', marginRight: '5px' }}
                                    type="checkbox"
                                    checked={stockTypeSelectedList.includes(item.StockType)}
                                    onChange={() => {
                                        handleStockTypeChange(item.StockType);
                                    }}
                                />

                                {item.StockType}
                            </label>
                        </div>
                    ))}
                </div>
            </>
        );
    }


    const handleBrandChange = (brandid) => {
        if (brandSelectedList.includes(brandid)) {
            setBrandSelectedList(brandSelectedList.filter((id) => id !== brandid));
        } else {
            setBrandSelectedList([...brandSelectedList, brandid]);
        }
    };

    const BrandView = () => {
        const [showView, setShowView] = useState(false);
        return (
            <>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                    onClick={() => {
                        setShowView(!showView)
                    }}
                >
                    <h5>Brands</h5>
                    <i className={showView ? "fa fa-caret-up" : "fa fa-caret-down"}
                        style={{ fontSize: '32px' }}

                    ></i>

                </div>
                {showView &&
                    <div className="container-alloc">
                        {brandMasterList.map((item) => (
                            <div key={item.BrandID} style={{ marginInline: '5px' }}>
                                <label>
                                    <input
                                        style={{ padding: '5px', marginRight: '5px' }}
                                        type="checkbox"
                                        checked={brandSelectedList.includes(item.BrandID)}
                                        onChange={() => {
                                            handleBrandChange(item.BrandID);
                                        }}
                                    />

                                    {item.BrandName}
                                </label>
                            </div>
                        ))}
                    </div>
                }

            </>
        );
    }

    const handleVendorChange = (vendor) => {
        if (stockTypeSelectedList.includes(vendor)) {
            setVendorSelectedList(vendorSelectedList.filter((id) => id !== vendor));
        } else {
            setVendorSelectedList([...vendorSelectedList, vendor]);
        }
    };

    const VendorView = () => {
        const [showView, setShowView] = useState(false);
        return (
            <>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                    onClick={() => {
                        setShowView(!showView)
                    }}
                >
                    <h5>Vendors</h5>
                    <i className={showView ? "fa fa-caret-up" : "fa fa-caret-down"}
                        style={{ fontSize: '32px' }}

                    ></i>
                </div>

                {showView &&

                    <div className="container-alloc">
                        {vendorMasterList.map((item) => (
                            <div key={item.Vendors} style={{ marginInline: '5px' }}>
                                <label>
                                    <input
                                        style={{ padding: '5px', marginRight: '5px' }}
                                        type="checkbox"
                                        checked={vendorSelectedList.includes(item.Vendors)}
                                        onChange={() => {
                                            handleVendorChange(item.Vendors);
                                        }}
                                    />

                                    {item.Vendors}
                                </label>
                            </div>
                        ))}
                    </div>
                }
            </>
        );
    }


    return (
        <>
            <TopNavbar />
            <Loader status={loader} />
            <div>
                <div className="desktopView">
                    <div style={{ padding: '20px', display: 'flex', flexDirection: 'row', }}>
                        {/* User List goes here */}
                        <div style={{ width: hasAddUpdate ? '60%' : '95%' }}>

                            <div style={{ marginBlock: '10px', width: '50%', }}>
                                <input
                                    style={{ width: '100%', padding: '8px' }}
                                    type="text"
                                    value={searchKey}
                                    placeholder="search by name"
                                    onChange={handleSearch}
                                />
                            </div>

                            <div className="user-list-container">

                                {filteredData.map((data) => {
                                    return (
                                        <div key={data.id} className="card" onClick={() => {
                                            handleClick(data);
                                        }}>

                                            <div>
                                                <span style={{ fontSize: '16px', fontWeight: 'bold' }}>{data.name}</span>
                                                <div>
                                                    <span>{data.emailid}</span>
                                                </div>
                                                <div>
                                                    <span>Created Date {data.createddate}</span>
                                                </div>
                                                <div>
                                                    <span>Created By {data.createdby}</span>
                                                </div>

                                            </div>




                                        </div>
                                    );
                                })}

                            </div>

                        </div>

                        {/* Add Edit User goes here */}

                        {hasAddUpdate &&
                            <div className="user-details-container">

                                <AddUpdateUser user={selectedUser} responseMessage={responseMessage} handleAddUser={handleAddUser}
                                    handleUpdateUser={handleUpdateUser}
                                    status={status}
                                    showMsg={showMsg}
                                    handleAllocationClick={handleAllocationClick}
                                    allocationCount={allocationCount}
                                    checkEmail={checkEmailExists}

                                />
                            </div>

                        }
                    </div>
                </div>
                <div className="mobileView">
                    <div className="searchWithList">

                        <div style={{ marginBlock: '10px', width: '90%', }}>
                            <input
                                style={{ width: '100%', padding: '8px' }}
                                type="text"
                                value={searchKey}
                                placeholder="search by name"
                                onChange={handleSearch}
                            />
                        </div>

                        <div className="user-list-container">

                            {filteredData.map((data) => {
                                return (
                                    <div key={data.id} className="card" onClick={() => {
                                        handleClick(data);
                                        setShowBottomSheet(true);
                                    }}>

                                        <div>
                                            <span style={{ fontSize: '16px', fontWeight: 'bold' }}>{data.name}</span>
                                            <div>
                                                <span>{data.emailid}</span>
                                            </div>
                                            <div>
                                                <span>Created Date {data.createddate}</span>
                                            </div>
                                            <div>
                                                <span>Created By {data.createdby}</span>
                                            </div>

                                        </div>

                                    </div>
                                );
                            })}

                        </div>

                    </div>


                    <div className="bottomView">


                        {
                            showBottomSheet && showBottomSheet ? <>
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <div
                                        onClick={() => {
                                            setSelectedUser(null)
                                            setShowBottomSheet(false)
                                        }}
                                        style={{ textAlign: 'right', padding: '8px', }}>
                                        <span style={{ fontSize: '18px', backgroundColor: 'khaki', paddingInline: '5px', borderRadius: '5px' }}>Close</span>
                                    </div>

                                    <AddUpdateUser user={selectedUser} responseMessage={responseMessage} handleAddUser={handleAddUser}
                                        handleUpdateUser={handleUpdateUser}
                                        status={status}
                                        showMsg={showMsg}
                                        handleAllocationClick={handleAllocationClick}
                                        allocationCount={allocationCount}
                                        checkEmail={checkEmailExists}
                                    />
                                </div>


                            </> :

                                <>
                                    {hasAddUpdate &&

                                        <div className="fab"
                                            onClick={() => {
                                                setSelectedUser(null)
                                                setShowBottomSheet(true)
                                            }}
                                        >
                                            <i className="fa fa-plus" />

                                        </div>

                                    }


                                </>
                        }



                    </div>

                </div>
                <Modal show={showAllocation} onHide={() => {
                    setShowAllocation(false)
                }} style={{ zIndex: '99999999999999', marginTop: "0px", }}>
                    <Modal.Header closeButton>
                        <Modal.Title>Allocation</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>

                        <CategoryView />
                        <SubCategoryView />
                        <BrandTypeView />
                        <StockTypeView />
                        <BrandView />
                        <VendorView />


                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => {
                            setShowAllocation(false)
                        }}>
                            Cancel
                        </Button>
                        <Button variant="primary" onClick={handleUpdateAllocation}>
                            Update Allocation
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>

        </>
    );
}